module.exports = __webpack_public_path__ + "img/logo-extensive.fc9cc9d8.svg";